<template>
  <div>
    <v-container id="audit" class="audit" bg="l">
      <v-headline :level="2" class="audit__headline form-headline text-b">{{
        dic.sectionAudit.title | toUpper
      }}</v-headline>

      <v-media :halfFilling="false" class="audit__container">
        <template v-slot:left>
          <infogram-audit class="margin_top margin_between" />
        </template>

        <template v-slot:right>
          <bitrix-audit-form
            class="audit__form margin_between"
            containerId="audit__form"
          />
        </template>
      </v-media>
    </v-container>

    <v-container bg="b">
      <v-media class="audit_media" :halfFilling="false" x="c" y="c">
        <template v-slot:left>
          <v-annotation>
            {{ dic.sectionAudit.footer.txt1 }}
            <a
              href="https://www.kmu.gov.ua/npas/pro-realizaciyu-eksperimentalnogo-pr-a1392r"
              >{{ dic.sectionAudit.footer.link }}</a
            >
            {{ dic.sectionAudit.footer.txt2 }} {{ dic.brand }}.
          </v-annotation>
        </template>

        <template v-slot:right>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 400">
            <path
              d="M120 0c-9.3 10.6-15 24.4-15 39.6.6 33.4 4.6 66.7 5 100 .7 31.1-8.6 60.3-19.9 88.8-3.8 7.9-7.9 15.6-12 23.3l-12-2.4c-10.8-2.2-17.9-12.7-15.7-23.5 1.9-9.5 10.2-16.1 19.5-16.1l4.4.5-9.8-81.6c-3.2-36.4-21.9-68.3-49.5-89-4.7-3.6-9.8-6.8-15-9.7v289.7h66.9c5 27.1 19.9 50.8 40.9 67 5 3.4 9.2 8 12.2 13.3 3-5.3 7.2-9.8 12.2-13.3 21-16.2 35.9-39.9 40.9-67H240V29.9c-5.2 2.9-10.3 6.1-15 9.7-27.6 20.7-46.3 52.6-49.5 88.9l-9.8 81.6 4.4-.5c9.3 0 17.6 6.6 19.5 16.1 2.2 10.8-4.9 21.4-15.7 23.5l-12 2.4c-4.1-7.7-8.2-15.4-12-23.3-11.3-28.5-20.7-57.7-19.9-88.8.4-33.4 4.4-66.7 5-100 0-15.1-5.7-28.9-15-39.5zM20 71.7c12.9 15.2 21.6 34.1 24.2 54.9l8 67.3c-10.2 5.1-18 14.5-20.9 25.8H20v-148zm200 0v148h-11.3c-2.9-11.3-10.7-20.7-20.9-25.8l8-67.3c2.6-20.8 11.3-39.8 24.2-54.9zM120 206.9c5.4 17.6 12.8 34.3 22 49.8-8.7 2.7-16.3 7.8-22 14.8-5.6-6.9-13.2-12.1-22-14.8 9.2-15.5 16.6-32.2 22-49.8zM20 239.7h11.3c3.6 13.8 14.3 24.7 28 28.5l9.6 2.2c-2.6 9.3-4 19.2-4 29.3H20v-60zm188.7 0H220v60h-45c0-10.1-1.4-20-4-29.3l9.6-2.2c13.7-3.8 24.5-14.7 28.1-28.5zM88.5 275c12.1 1.7 21.5 12.1 21.5 24.7H85c0-8.6 1.3-16.9 3.5-24.7zm63 0c2.2 7.9 3.5 16.1 3.5 24.7h-25c0-12.6 9.4-23 21.5-24.7zm-64.2 44.7H110v42.1c-11-11.5-19-26-22.7-42.1zm42.7 0h22.7c-3.7 16.1-11.7 30.6-22.7 42.1v-42.1z"
              fill="#ffe449"
            />
          </svg>
        </template>
      </v-media>
    </v-container>
  </div>
</template>

<script>
import VHeadline from '@/components/ui/VHeadline'
import VAnnotation from '@/components/ui/VAnnotation'
import BitrixAuditForm from '@/components/bitrix/BitrixAuditForm'
import InfogramAudit from '@/components/ui/InfogramAudit'
import VContainer from '@/components/ui/VContainer'
import VMedia from '@/components/ui/VMedia'

export default {
  components: {
    InfogramAudit,
    VContainer,
    VMedia,
    BitrixAuditForm,
    VHeadline,
    VAnnotation,
  },
  computed: {
    currentLang() {
      //this need for wake up store listner 
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner 
      return this.$store.state.main.dic
    },
  },
}
</script>

<style lang="scss" scoped>
.audit_media {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

a,
a:visited {
  color: #fff;
}

svg {
  width: 60px;
}

.margin_between {
  margin-left: 40px;
  margin-right: 40px;
}

.margin_top {
  margin-top: 50px;
}

.audit__headline {
  text-align: center;
}

.audit__form {
  width: 450px;
}

.audit__container {
  justify-content: center;
  align-items: flex-start;
  flex-wrap: nowrap;
}
</style>

<style lang="scss" scoped>
@media (max-width: 1024px) {
  .margin_between {
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media (max-width: 990px) {
  .margin_between {
    margin-left: 0px;
    margin-right: 0px;
  }

  .audit__container {
    flex-wrap: wrap;
  }
}

@media (max-width: 768px) {
  .audit_media {
    flex-wrap: wrap-reverse;
  }
}

@media (max-width: 414px) {
  .audit__form {
    width: 413px;
  }
}

@media (max-width: 375px) {
  .audit__form {
    width: 374px;
  }
}
</style>
